import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import {
    FormComponent,
    IFormFields,
} from '@components/ui-upsert-page/ui-form.component';
import { IQueueTrigger } from '@models';
import {
    ITEMS_ACTIVATION_MAX,
    ITEMS_PER_JOB_ACTIVATION_MAX,
    MAX_JOBS_ACTIVATION_MAX,
} from '@pages/triggers/upsert/trigger.upsert.page.models';
import {
    QueueDefinitionService,
    TransactionService,
} from '@services';

import { switchMap } from 'rxjs/operators';

@Component({
    selector: 'ui-queue-trigger',
    templateUrl: './queue-trigger.component.html',
    styleUrls: ['./queue-trigger.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        TransactionService,
    ],
    encapsulation: ViewEncapsulation.None,
})
export class QueueTriggerComponent extends FormComponent<IQueueTrigger> {

    public get itemsActivationThresholdMax() { return ITEMS_ACTIVATION_MAX; }
    public get itemsPerJobActivationTargetMax() { return ITEMS_PER_JOB_ACTIVATION_MAX; }
    public get maxJobsForActivationMax() { return MAX_JOBS_ACTIVATION_MAX; }

    @Input()
    public form!: FormGroup;

    @Input()
    public fields!: IFormFields<IQueueTrigger>;

    @Input()
    public triggerId!: number;

    constructor(
        private _appState: AppStateFacade,
        private _queueService: QueueDefinitionService,
    ) {
        super();
    }

    public queueSearchFactory = (searchTerm: string | undefined, fetchSize: number | undefined, skipCount: number) =>
        this._appState.user.folder.value$
            .pipe(
                switchMap(_ =>
                    this._queueService.queueTriggerSuggest(this.triggerId, searchTerm, fetchSize, skipCount),
                ),
            )

    public changedMaxJobsForActivation(max: string) {
        if (Number(max) !== 1) { return; }

        this.getField('itemsPerJobActivationTarget').setValue(1);
    }
}
